module.exports = __webpack_public_path__ + "img/thumbnail_ReticulatedGiraffe_m_albino.e3090b2a.png";